import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../api/store";
import { SubChannelPayload } from "../../../types/type";
import { StepsChannelProposalAsState } from "./steps-channel-proposal_as.state";
import { SubTypeOption } from "../../../api/gms/group-category/group-category-api-state";

const initialState: StepsChannelProposalAsState = {
    // steps
    currentStep: 1,
    // channel type
    selectedChannelBox: null,
    channelSubName: null,
    channelNumber: null,
    channelEmail: null,
    // proposal as (New/Renew)
    selectProposalAs: null,
    // for renew
    selectedProposalRenew: null,
    secRegisteredName: null,
    proposalExpiredAt: null,
    // current group name
    currentGroupName: null,
    // current status
    currentStatus: null,
};

const stepsChannelProposalAsSlice = createSlice({
    name: "stepsChannelProposalAsSliceSlice",
    initialState,
    reducers: {
        setCurrentStep: (state, action: PayloadAction<number>) => {
            state.currentStep = action.payload;
        },
        setChannelType: (state, action: PayloadAction<SubTypeOption>) => {
            state.selectedChannelBox = action.payload;
            state.channelSubName = null;
            state.channelNumber = null;
            state.channelEmail = null;
        },
        setSubChannelValue: (state, action: PayloadAction<SubChannelPayload>) => {
            const { type, value } = action.payload;

            switch (type) {
                case "name":
                state.channelSubName = value;
                break;

                case "number":
                state.channelNumber = value;
                break;

                case "email":
                state.channelEmail = value;
                break;
            }
        },
        updateChannelAndSubName: ( state, action: PayloadAction<{ selectedChannelBox: SubTypeOption | null; channelSubName: string | null; channelSubNumber: string | null, channelSubEmail: string | null}> ) => {
            state.selectedChannelBox = action.payload.selectedChannelBox;
            state.channelSubName = action.payload.channelSubName;
            state.channelNumber = action.payload.channelSubNumber;
            state.channelEmail = action.payload.channelSubEmail;
        },
        updateCommissionRate: (
            state,
            action: PayloadAction<{
                selectedChannelBox: SubTypeOption | null;
                channelSubName: string | null;
            }>
        ) => {
            state.selectedChannelBox = action.payload.selectedChannelBox;
            state.channelSubName = action.payload.channelSubName;
        },
        // FOR RENEW/NEW
        setProposalType: (state, action: PayloadAction<SubTypeOption>) => {
            state.selectProposalAs = action.payload;
        },
        setSECNameRenew: (state, action: PayloadAction<string>) => {
            state.secRegisteredName = action.payload;
        },
        setSelectedProposalToRenew: (state, action: PayloadAction<SubTypeOption>) => {
            state.selectedProposalRenew = action.payload;
        },
        // PROPOSAL EXPIRED AT
        setProposalExpiredAt: (state, action: PayloadAction<string | null>) => {
            state.proposalExpiredAt = action.payload;
        },

        setCurrentGroupName: (state, action: PayloadAction<null | string>) => {
            state.currentGroupName = action.payload;
        },
        setCurrentStatus: (state, action: PayloadAction<null | string>) => {
            state.currentStatus = action.payload;
        },
        resetChannelCommissionService: () => ({ ...initialState }),
    },
});

export const {
    // steps
    setCurrentStep,
    // Proposal As
    setChannelType,
    setSubChannelValue,
    // setCommissionValue,
    // setServiceValue,
    updateChannelAndSubName,
    resetChannelCommissionService,
    setProposalType,
    setSECNameRenew,
    setSelectedProposalToRenew,
    setProposalExpiredAt,

    setCurrentGroupName,
    setCurrentStatus,
} = stepsChannelProposalAsSlice.actions

// steps
export const selectCurrentStep = (state: RootState) => state.stepsChannelProposalAsSliceSlice.currentStep;
// channel type
export const selectChannelTypeState = (state: RootState) => state.stepsChannelProposalAsSliceSlice.selectedChannelBox;
export const selectChannelSubNameState = (state: RootState) => state.stepsChannelProposalAsSliceSlice.channelSubName;
export const selectChannelSubNumberState = (state: RootState) => state.stepsChannelProposalAsSliceSlice.channelNumber;
export const selectChannelSubEmailState = (state: RootState) => state.stepsChannelProposalAsSliceSlice.channelEmail;
// Proposal As
export const selectProposalAs = (state: RootState) => state.stepsChannelProposalAsSliceSlice.selectProposalAs;
// Renew
export const selectProposalRenew = (state: RootState) => state.stepsChannelProposalAsSliceSlice.selectedProposalRenew;
// Register name for renew
export const selectSECRegisteredName = (state: RootState) => state.stepsChannelProposalAsSliceSlice.secRegisteredName;
// Register expired
export const selectProposalExpiredAt = (state: RootState) => state.stepsChannelProposalAsSliceSlice.proposalExpiredAt;
 // Current Groupname
export const selectProposalCurrentGroupName = (state: RootState) => state.stepsChannelProposalAsSliceSlice.currentGroupName;

export const selectProposalCurrentStatus = (state: RootState) => state.stepsChannelProposalAsSliceSlice.currentStatus;

export default stepsChannelProposalAsSlice.reducer;